import { Grid, Skeleton } from '@mui/material';
import React from 'react';
import { PublicationFeed } from "views/knowledge/components/card";
import { CardBuilder } from "views/knowledge/components/card/CardBuilder";

////////////////////////////////////////////////////////////////////////////////

export const CardSkeleton: React.FC<{ visible: boolean; }> = ({ visible }) => {
    return visible
        ? <CardBuilder
            dataRecord={{} as PublicationFeed}
            onDataItemChanged={() => { }}
            onNeedResetRowHeight={() => { }}
            onReload={() => null}
            Title={() => { return <Skeleton variant="rectangular" width={630} height={22} />; }}
            Author={() => {
                return (
                    <Grid container justifyContent="center" alignItems="center" spacing={1}>
                        <Grid>
                            <Skeleton variant="circular" width={40} height={40} />
                        </Grid>
                        <Grid size="grow">
                            <Skeleton variant="rectangular" width={580} height={22} />
                        </Grid>
                    </Grid>
                );
            }}
            Content={() => { return <Skeleton variant="rectangular" width={630} height={60} />; }}
            Footer={() => {
                return (
                    <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
                        <Grid>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid>
                                    <Skeleton variant="circular" width={16} height={16} />
                                </Grid>
                                <Grid>
                                    <Skeleton variant="circular" width={16} height={16} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid>
                            <Skeleton variant="circular" width={16} height={16} />
                        </Grid>
                    </Grid>
                );
            }}
        />
        : null;
};

export const CardListHeaderSkeleton: React.FC<{ visible: boolean; }> = ({ visible }) => {
    return visible
        ? <CardBuilder
            dataRecord={{} as PublicationFeed}
            onDataItemChanged={() => { }}
            onNeedResetRowHeight={() => { }}
            onReload={() => null}
            Author={() => {
                return (
                    <Grid container justifyContent="center" alignItems="flex-start" spacing={1}>
                        <Grid>
                            <Skeleton variant="rounded" width={154} height={87} />
                        </Grid>
                        <Grid size="grow">
                            <Skeleton variant="rectangular" width={80} height={22} />
                            <br />
                            <Skeleton variant="rectangular" width={30} height={16} />
                        </Grid>
                    </Grid>
                );
            }}
        />
        : null;
};
